import { useCallback, useState } from 'react'

import { api } from '../api'

export function useWorkspaceBootstrap() {
  const [status, setStatus] = useState(null)
  const [catalog, setCatalog] = useState(null)
  const [metadata, setMetadata] = useState(null)
  const [synonyms, setSynonyms] = useState({ measures: {}, dimensions: {}, values: {} })
  const [businessSemantic, setBusinessSemantic] = useState({ columns: [], items: [] })
  const [loadingStatus, setLoadingStatus] = useState(true)
  const [globalError, setGlobalError] = useState('')

  const bootstrap = useCallback(async () => {
    setLoadingStatus(true)
    try {
      const [health, metadataCatalog, metadataPayload, synonymPayload, businessSemanticPayload, connectionTest] = await Promise.all([
        api.getStatus(),
        api.getCatalog({ include_system_tables: false }),
        api.getMetadata({ include_system_tables: false }),
        api.getSynonyms(),
        api.getBusinessSemantic(),
        api.getSemanticConnectionTest().catch((error) => ({ ok: false, error: error.message })),
      ])
      setStatus({
        ...health,
        semanticConnected: Boolean(connectionTest?.ok),
        semanticConnectionError: connectionTest?.error || '',
        semanticConnectionUrl: connectionTest?.execute_queries_url || health?.semanticExecuteQueriesUrl || '',
        semanticConfigured: Boolean(health?.semanticConfigured),
      })
      setCatalog(metadataCatalog)
      setMetadata(metadataPayload)
      setSynonyms(synonymPayload)
      setBusinessSemantic(businessSemanticPayload)
      setGlobalError('')
    } catch (error) {
      setGlobalError(error.message)
    } finally {
      setLoadingStatus(false)
    }
  }, [])

  return {
    status,
    catalog,
    metadata,
    synonyms,
    setSynonyms,
    businessSemantic,
    setBusinessSemantic,
    loadingStatus,
    globalError,
    setGlobalError,
    bootstrap,
  }
}
